import "./styles/global.css";
import { applyRouteMeta } from "./meta";
import { getPath, onRouteChange } from "./router";
import { mountShell } from "./shell";
import { hydrateArt } from "./pages/art";
import { hydrateHome } from "./pages/home";
import { hydrateMusic } from "./pages/music";
import { hydrateQuiz } from "./pages/games";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("#app missing");

function boot(): void {
  const path = getPath();
  mountShell(root, path);
  applyRouteMeta();
  const main = root.querySelector<HTMLElement>(".sanoi-main");
  if (!main) return;
  /** 不 await：避免 JSON 拉取阻塞路由切换；各 hydrate 内部在 await 后检查节点仍挂载 */
  if (path === "/") hydrateHome(main);
  if (path === "/art") hydrateArt(main);
  if (path === "/music") hydrateMusic(main);
  if (path === "/games") hydrateQuiz(main);
}

onRouteChange(() => {
  void boot();
});

void boot();
